import { render } from "./AddProductItemModal.vue?vue&type=template&id=47f3c09e&scoped=true&ts=true"
import script from "./AddProductItemModal.vue?vue&type=script&lang=ts"
export * from "./AddProductItemModal.vue?vue&type=script&lang=ts"

import "./AddProductItemModal.vue?vue&type=style&index=0&id=47f3c09e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f3c09e"]])

export default __exports__